export default __webpack_public_path__ + "static/media/img-41-aubury.564537d4.jpg";